export {default} from './AppNotificationsContainer';



// WEBPACK FOOTER //
// ./src/containers/AppNotificationsContainers/index.ts